import { createAction, props } from '@ngrx/store';

import { MobileUsersGetResponse } from '../../typings/mobile-users';
import { OldState } from '../../typings/storage';
import { SystemConfigurationsMobileSettingsResponse } from '../../typings/system-configurations';
import { SmdState } from '../index';

export const loadPersistedStateSuccess = createAction(
  '[Persisted State] Load Persisted State Success',
  props<{
    payload: SmdState;
  }>()
);

export const loadPersistedStateFailure = createAction(
  '[Persisted State] Load Persisted State Failure',
  props<{ payload: { error: Error } }>()
);

export const migratePersistedOldStateReferralCode = createAction(
  '[Persisted State] Migrate Persisted Old State Referral Code',
  props<{
    payload: OldState;
  }>()
);

export const migratePersistedOldStateReferralCodeSuccess = createAction(
  '[Persisted State] Migrate Persisted Old State Referral Code Success',
  props<{
    payload: {
      code: string;
      data: SystemConfigurationsMobileSettingsResponse;
      state: OldState;
    };
  }>()
);

export const migratePersistedOldStateFailure = createAction(
  '[Persisted State] Migrate Persisted Old State Failure',
  props<{
    payload: { error: Error };
  }>()
);

export const migratePersistedOldStateUserDataSuccess = createAction(
  '[Persisted State] Migrate Persisted Old State User Data Success',
  props<{
    payload: {
      data: MobileUsersGetResponse;
      id: string;
      state: OldState;
    };
  }>()
);

export const migratePersistedOldStateDataProviderCredentialsSuccess = createAction(
  '[Persisted State] Migrate Persisted Old State Data Provider Credentials Success',
  props<{
    payload: {
      data: {
        password: string | null;
        username: string | null;
      };
      state: OldState;
    };
  }>()
);

export const migratePersistedOldStateAlternateIconSuccess = createAction(
  '[Persisted State] Migrate Persisted Old State Alternate Icon Success',
  props<{
    payload: {
      state: OldState;
      useDefault: boolean;
    };
  }>()
);

export const persistedStateReset = createAction('[Persisted State] Reset Persisted State');
